<template>
  <div>
    <div v-if="componentData.direction == 'Horizontal'">
      <div class="instruction_title text-left para-mrgn-20" v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" v-html="question.formattedBody" />
      <div @click.once="$emit('onClick', question)">
        <div class="row" id="ds-label">
          <div class="pl-0 col-md-2 ds-label-normal"></div>
          <ds-slider
            ref="slider"
            v-if="componentData.partitions !== 0"
            :value="getValueForNumberScale()"
            :name="`ds-slider-select-${question.identifier}`"
            :piecewise="true"
            direction="horizontal"
            tooltip="none"
            class="horizontal-vue-slider pt-30 col-md-8"
            :class="{ 'box-slider': !!componentData.numericRatingScale }"
            :min="componentData.minValue"
            :max="componentData.maxValue"
            :piecewiseLabel="true"
            :piecewiseStyle="piecewiseStyle"
            :interval="componentData.partitions"
            :piecewiseActiveStyle="piecewiseActiveStyle"
            :labelActiveStyle="labelActiveStyle"
            :disabled="isFieldDisabled"
            @drag-end="onFieldChange"
            @click-end="OnClick"
            :dotSize="pointerValue"
            :isNumericRatingScale="!!componentData.numericRatingScale"
            :defaultSelected="numericScaleSelected"
          ></ds-slider>
          <ds-slider
            ref="slider"
            v-else
            :value="getValueForNumberScale()"
            :name="`ds-slider-select-${question.identifier}`"
            direction="horizontal"
            tooltip="none"
            class="horizontal-vue-slider pt-30 col-md-8"
            :class="{ 'box-slider': !!componentData.numericRatingScale }"
            :min="componentData.minValue"
            :max="componentData.maxValue"
            :labelActiveStyle="labelActiveStyle"
            @drag-end="onFieldChange"
            @click-end="OnClick"
            :disabled="isFieldDisabled"
            :dotSize="pointerValue"
            :isNumericRatingScale="!!componentData.numericRatingScale"
            :defaultSelected="numericScaleSelected"
          >
          </ds-slider>
          <div class="pr-0 col-md-2"></div>
        </div>
        <div class="row">
          <div v-if="componentData && componentData.minValueLabel" class="pl-0 col-md-4 ds-label-normal mt-10" v-translate:dynamic_string="{ key: `${translationKeyInitial}_minValueLabel`, val: lang, html: componentData.minValueLabel }">{{ componentData.minValueLabel }}</div>
          <div class="pr-0 col-md-4"></div>
          <div v-if="componentData && componentData.maxValueLabel" class="pr-0 col-md-4 ds-label-normal mt-10" v-translate:dynamic_string="{ key: `${translationKeyInitial}_maxValueLabel`, val: lang, html: componentData.maxValueLabel }">{{ componentData.maxValueLabel }}</div>
        </div>
      </div>
    </div>
    <div class="option-section pad-top20" v-if="componentData.direction == 'Vertical'">
      <div class="instruction_title text-left para-mrgn-20" v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" v-html="question.formattedBody" />
      <div style="height: 255px;">
        <div v-if="componentData && componentData.maxValueLabel" class="scaleLabels text-center mb-10" v-translate:dynamic_string="{ key: `${translationKeyInitial}_maxValueLabel`, val: lang, html: componentData.maxValueLabel }">{{ componentData.maxValueLabel }}</div>
        <ds-slider
          ref="slider"
          v-if="componentData.partitions !== 0"
          :value="getValueForNumberScale()"
          :name="`ds-slider-select-${question.identifier}`"
          :piecewise="true"
          direction="vertical"
          tooltip="none"
          class="vertical-vue-slider moz-style pl-20"
          width="1"
          :min="componentData.minValue"
          :max="componentData.maxValue"
          :piecewiseLabel="true"
          :piecewiseStyle="piecewiseStyle"
          :interval="componentData.partitions"
          :piecewiseActiveStyle="piecewiseActiveStyle"
          :labelActiveStyle="labelActiveStyle"
          @drag-end="onFieldChange"
          @click-end="OnClick"
          :disabled="isFieldDisabled"
          style="text-align: -webkit-center"
          :dotSize="pointerValue"
          :isNumericRatingScale="!!componentData.numericRatingScale"
          :defaultSelected="numericScaleSelected"
        ></ds-slider>
        <ds-slider
          ref="slider"
          v-else
          :value="getValueForNumberScale()"
          :name="`ds-slider-select-${question.identifier}`"
          direction="vertical"
          tooltip="none"
          class="vertical-vue-slider pl-20"
          width="2"
          :min="componentData.minValue"
          :max="componentData.maxValue"
          :disabled="isFieldDisabled"
          :labelActiveStyle="labelActiveStyle"
          @drag-end="onFieldChange"
          @click-end="OnClick"
          :dotSize="pointerValue"
          :isNumericRatingScale="!!componentData.numericRatingScale"
          :defaultSelected="numericScaleSelected"
        ></ds-slider>
        <div v-if="componentData && componentData.minValueLabel" class="scaleLabels text-center mt-10" v-translate:dynamic_string="{ key: `${translationKeyInitial}_minValueLabel`, val: lang, html: componentData.minValueLabel }">{{ componentData.minValueLabel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

import dsSlider from "@/lib/ds-slider-component";

export default {
  name: "number-scale",
  mixins: [langTranslate],
  data() {
    return {
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      piecewiseActiveStyle: {
        backgroundColor: "#ccc"
      },
      labelActiveStyle: {
        color: ""
      },
      pointerValue: 0,
      numericScaleSelected: false
    };
  },
  mounted() {
    this.question.answer = this.getValueForNumberScale();
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
    if (this.question.answer) {
      this.numericScaleSelected = true;
      this.pointerValue = 16;
      this.piecewiseActiveStyle.backgroundColor = "#3498db";
      this.labelActiveStyle.color = "#3498db";
    }
  },
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  components: {
    dsSlider
  },
  methods: {
    onFieldChange(event) {
      this.question.answer = event.val;
      this.onAnswerChange();
    },
    getValueForNumberScale() {
      if (this.question.answer === undefined) return;
      if (this.question.skipped) {
        this.numericScaleSelected = false;
        this.pointerValue = 0;
        this.piecewiseActiveStyle.backgroundColor = "#ccc";
        this.labelActiveStyle.color = "";
        return;
      }
      if (!this.question.hasOwnProperty("answer") || this.question.answer === false) {
        return undefined;
      }
      if (this.question.answer || this.question.answer === 0) {
        return this.question.answer;
      }
      return undefined;
    },
    onAnswerChange(e) {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.question);
      });
    },
    OnClick(event) {
      this.question.skipped = false;
      this.pointerValue = 16;
      this.piecewiseActiveStyle.backgroundColor = "#3498db";
      this.labelActiveStyle.color = "#3498db";
      this.question.answer = event.val;
      this.onAnswerChange();
    },
    clearAnswer(){
      this.question.answer = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
    }
  },
};
</script>

<style>
.box-slider .vue-box-select li {
  margin: 0 1% !important;
}
#ds-label .ds-label-normal {
  word-wrap: normal !important;
}
.vertical-vue-slider.moz-style {
  text-align: -moz-center !important;
}
</style>
